'use strict';

var AjaxFormInPlaceTransition = function(ajaxForm, formParent) {
    this.initialize(ajaxForm, formParent);
};

AjaxFormInPlaceTransition.prototype = {
    ajaxForm: null,
    formParent: null,
    transitionable: null,

    initialize: function(ajaxForm, formParent){
        this.ajaxForm = ajaxForm;
        this.formParent = document.getElementById(formParent);

        var inplacedom = document.createElement('div');
        inplacedom.style.display = 'none';
        document.body.appendChild(inplacedom);

        this.ajaxForm.setContentContainer(inplacedom);
        this.ajaxForm.addCompleteEvent(function(){
            var containingNode = this.formParent.parentNode;
            var newParentNode = this.ajaxForm.getContentContainer();

            var transitionableElement = this.transitionable.getElement();
            if(transitionableElement != null){
                newParentNode.appendChild(transitionableElement);
            }
            inplacedom.style.display = '';
            this.transitionable.setExitParticipant(newParentNode);
            containingNode.replaceChild(newParentNode, this.formParent);
            this.transitionable.exitTransition.bind(this.transitionable)();

            this.formParent = null;
        }.bind(this));
    },

    /**
     * @param element The ID of the element.
     * @param transitionable
     * NOTE: There is the potential that this method will go away at some future point, as the intention is that this was meant to maintain
     * visual consistency with MITS Report.  However, the question of whether or not we should still be doing so is up in the air.
     */
    registerTransitionable: function (element, transitionable) {
        //TODO: Rehook this to the click events
        this.ajaxForm.addSubmitEvent(function () {
            this.transitionable = transitionable;
            transitionable.enterTransition.bind(transitionable)();
        }.bind(this));
    },

    toString: function () {
        return '[MITS.Widgets.AjaxFormInPlaceTransition]';
    }
};

module.exports = AjaxFormInPlaceTransition;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/AjaxFormInPlaceTransition.js
// module id = 29
// module chunks = 0